// "/research" matches "/research" and "/research/<slug>", not "/researchX" (case-insensitive, as the routes are)
const under = (path, base) => {
  const p = path.toLowerCase();
  const b = base.toLowerCase();
  return p === b || p.startsWith(b === "/" ? b : `${b}/`);
};

// Which navbar link marks the current page (navbar.js); no router import, so it can be unit-tested.
// "page" when this is the link's own page, "true" when the page sits under it, otherwise null.
export const navCurrent = (link, pathname) => {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (link.end) return path === link.to ? "page" : null;
  if (under(path, link.to)) return path.toLowerCase() === link.to.toLowerCase() ? "page" : "true";
  return (link.also || []).some((b) => under(path, b)) ? "true" : null;
};
